/* WALKO VOYAGE — script commun : bandeau, menu, panier, cadeaux automatiques.
   Cadeaux (équivalent réécrit de cart-gift-reconciliation) :
   - « Cadeau surprise » (0 €) : présent tant qu'il y a au moins 1 breloque ou 1 support WALKO voyage dans le panier ;
   - « Kit de voyage » (0 €) : présent dès 5 breloques (drapeaux + cartes) ;
   - gravures orphelines : une ligne « Gravure » suit la quantité de la breloque gravée qui porte le même _wv_grp.
   - support offert dès 10 breloques (MAJ 22/10) : Shopify ne cumule pas cette remise avec le −50 % des breloques, donc
     le script remplace UNE ligne de support payant (la moins chère) par la variante 0 € du produit caché « Support offert »
     (hors collections) ; sous 10 breloques, il remet la variante payante. Les propriétés de ligne sont conservées.
   Le −50 % par breloque et le 1 support acheté = 1 offert restent des REMISES AUTOMATIQUES Shopify (voir ETAT.md).
   PATCHS (MAJ 25/10, WV.patch de wv-patch-data) : un patch compte pour le cadeau surprise (un seul par commande, breloques
   et patchs mêlés) ; « Pochette de voyage » (0 €) présente dès 10 patchs. Sans ids patch (null), rien ne change. */
(function () {
  'use strict';
  var WV = window.WV = window.WV || {};
  var cfg = function () { return WV.cfg || {}; };

  WV.euros = function (cents) {
    var n = Math.round(cents) / 100;
    return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  };

  function jsonFetch(url, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { var e = new Error(d.description || d.message || ('Erreur ' + r.status)); e.status = r.status; throw e; }
        return d;
      });
    });
  }
  WV.jsonFetch = jsonFetch;

  function majCompteur(cart) {
    var el = document.querySelector('[data-wv-cart-count]');
    if (!el || !cart) return;
    el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
  }

  /* Correspondances support payant <-> variante 0 € « Support offert » (depuis WV.cfg.supports[].choix[].offert) */
  WV.supportsOfferts = function () {
    var versOffert = {}, versPayant = {}, prix = {};
    (cfg().supports || []).forEach(function (ty) {
      (ty.choix || []).forEach(function (x) { if (x.offert) { versOffert[x.id] = x.offert; versPayant[x.offert] = x.id; prix[x.id] = x.prix; } });
    });
    return { versOffert: versOffert, versPayant: versPayant, prix: prix };
  };
  /* Remise réelle du −50 % Shopify sur les breloques : arrondie au centime inférieur PAR UNITÉ
     (vérifié en caisse le 22/10 : 10,95 € → remise 5,47 €, payé 5,48 € ; ligne × 3 → remise 16,41 €). */
  WV.remiseBreloque = function (prixUnitaire, quantite) { return Math.floor(prixUnitaire / 2) * (quantite || 1); };
  /* Prix réel des supports (centimes) : dès 10 breloques le moins cher passe à 0 € (échange), puis « 1 support acheté
     = 1 offert » (BXGY Shopify sur supports-breloques) offre les moins chers des supports payants restants. */
  WV.prixSupports = function (prixListe, nBreloques) {
    var p = prixListe.slice().sort(function (a, b) { return a - b; }), offertEchange = 0, bxgy = 0, i;
    if (nBreloques >= ((cfg().paliers || {}).support || 10) && p.length) offertEchange = p.shift();
    for (i = 0; i < Math.floor(p.length / 2); i++) bxgy += p[i];
    return { offertEchange: offertEchange, bxgy: bxgy };
  };

  /* Calcule les corrections de cadeaux à faire sur un panier (pur, testable). */
  WV.planCadeaux = function (cart) {
    var c = cfg(), P = c.produits || {}, V = c.variantes || {}, S = c.paliers || { surprise: 1, kit: 5, support: 10 };
    var PT = WV.patch || {}, PTP = PT.produits || {}, PTV = PT.variantes || {}, PTS = PT.paliers || { pochette: 10 };
    var vendables = [P.drapeau, P.carte, P.porteCles, P.bracelet, P.collier, P.chaine, P.supportOffert];
    if (PTP.patch) vendables.push(PTP.patch);
    var breloques = [P.drapeau, P.carte];
    var SO = WV.supportsOfferts();
    var nReel = 0, nBreloques = 0, nPatchs = 0, grp = {}, maj = {}, ajouts = [];
    var lignes = { surprise: [], kit: [], gravure: [], supPayants: [], supOfferts: [], pochette: [] };
    (cart.items || []).forEach(function (it) {
      var pr = it.properties || {};
      if (SO.versOffert[it.variant_id]) lignes.supPayants.push(it);
      if (SO.versPayant[it.variant_id]) lignes.supOfferts.push(it);
      if (vendables.indexOf(it.product_id) > -1) nReel += it.quantity;
      if (breloques.indexOf(it.product_id) > -1) {
        nBreloques += it.quantity;
        if (pr._wv_grp) grp[pr._wv_grp] = (grp[pr._wv_grp] || 0) + it.quantity;
      }
      if (PTP.patch && it.product_id === PTP.patch) nPatchs += it.quantity;
      if (PTV.pochette && it.variant_id === PTV.pochette) lignes.pochette.push(it);
      if (it.variant_id === V.surprise) lignes.surprise.push(it);
      if (it.variant_id === V.kit) lignes.kit.push(it);
      if (it.variant_id === V.gravure && pr._wv_grp) lignes.gravure.push(it);
    });
    function regle(liste, voulu, variante) {
      if (voulu) {
        if (!liste.length) ajouts.push({ id: variante, quantity: 1, properties: { _wv_cadeau: '1' } });
        liste.forEach(function (it, i) { var q = i === 0 ? 1 : 0; if (it.quantity !== q) maj[it.key] = q; });
      } else {
        liste.forEach(function (it) { maj[it.key] = 0; });
      }
    }
    regle(lignes.surprise, nReel >= (S.surprise || 1), V.surprise);
    regle(lignes.kit, nBreloques >= (S.kit || 5), V.kit);
    if (PTV.pochette) regle(lignes.pochette, nPatchs >= (PTS.pochette || 10), PTV.pochette);
    lignes.gravure.forEach(function (it) {
      var q = grp[it.properties._wv_grp] || 0;
      if (it.quantity !== q) maj[it.key] = q;
    });
    /* Support offert : exactement 1 unité « Support offert » dès 10 breloques s'il y a un support, 0 sinon */
    function props(it) { var o = {}, pr = it.properties || {}; for (var k in pr) if (pr[k] !== null && pr[k] !== '') o[k] = pr[k]; return o; }
    var voulu = nBreloques >= (S.support || 10) ? 1 : 0, nOfferts = 0;
    lignes.supOfferts.forEach(function (it) { nOfferts += it.quantity; });
    if (nOfferts > voulu) {
      var trop = nOfferts - voulu;
      lignes.supOfferts.forEach(function (it) {
        if (!trop) return;
        var q = Math.min(trop, it.quantity); trop -= q;
        maj[it.key] = it.quantity - q;
        ajouts.push({ id: SO.versPayant[it.variant_id], quantity: q, properties: props(it) });
      });
    } else if (nOfferts < voulu && lignes.supPayants.length) {
      var moinsCher = lignes.supPayants.slice().sort(function (a, b) { return (SO.prix[a.variant_id] || a.price) - (SO.prix[b.variant_id] || b.price); })[0];
      maj[moinsCher.key] = moinsCher.quantity - 1;
      ajouts.push({ id: SO.versOffert[moinsCher.variant_id], quantity: 1, properties: props(moinsCher) });
    }
    /* OFFRE 3,95 € (MAJ 28/10, WV.offre de wv-data) : porte-clés de l'offre offert dès 15 breloques de l'offre.
       Exactement 1 unité « offert » (0 €) dès 15 s'il y a un porte-clés de l'offre, 0 sinon (même mécanique que le support offert). */
    var OF = WV.offre, nOffre = 0;
    if (OF && OF.produits) {
      var pcVersOffert = {}, pcVersPayant = {}, pcPay = [], pcOff = [], nPcOff = 0;
      (OF.pc || []).forEach(function (x) { pcVersOffert[x.id] = x.offert; pcVersPayant[x.offert] = x.id; });
      (cart.items || []).forEach(function (it) {
        if (it.product_id === OF.produits.breloque) nOffre += it.quantity;
        if (pcVersOffert[it.variant_id]) pcPay.push(it);
        if (pcVersPayant[it.variant_id]) { pcOff.push(it); nPcOff += it.quantity; }
      });
      var pcVoulu = nOffre >= (OF.pcOffert || 15) ? 1 : 0;
      if (nPcOff > pcVoulu) {
        var tropPc = nPcOff - pcVoulu;
        pcOff.forEach(function (it) {
          if (!tropPc) return;
          var q = Math.min(tropPc, it.quantity); tropPc -= q;
          maj[it.key] = it.quantity - q;
          ajouts.push({ id: pcVersPayant[it.variant_id], quantity: q, properties: props(it) });
        });
      } else if (nPcOff < pcVoulu && pcPay.length) {
        var pc0 = pcPay[0];
        maj[pc0.key] = pc0.quantity - 1;
        ajouts.push({ id: pcVersOffert[pc0.variant_id], quantity: 1, properties: props(pc0) });
      }
    }
    return { maj: maj, ajouts: ajouts, nReel: nReel, nBreloques: nBreloques, nPatchs: nPatchs, nOffre: nOffre };
  };

  var enCours = null;
  WV.reconcilier = function () {
    if (enCours) return enCours;
    enCours = jsonFetch('/cart.js').then(function (cart) {
      var plan = WV.planCadeaux(cart);
      var etapes = Promise.resolve(cart), change = false;
      if (Object.keys(plan.maj).length) { change = true; etapes = etapes.then(function () { return jsonFetch('/cart/update.js', { updates: plan.maj }); }); }
      if (plan.ajouts.length) { change = true; etapes = etapes.then(function () { return jsonFetch('/cart/add.js', { items: plan.ajouts }); }); }
      return etapes.then(function () { return change ? jsonFetch('/cart.js') : cart; })
        .then(function (c2) { c2.wvChange = change; return c2; });
    }).then(function (cart) { majCompteur(cart); return cart; })
      .finally(function () { enCours = null; });
    return enCours;
  };


  /* Galerie produit (configurateur + fiches supports) : vrai swipe au doigt via une piste à défilement
     horizontal natif + scroll-snap (le geste vertical reste celui de la page), compteur « 1 / 9 »,
     vignettes synchronisées, flèches sur desktop. Le rendu « grande breloque » devient la 1re diapo.
     API : WV.galerie(el) → { aller(i), suivant(), precedent(), montrerBig(), index() }. */
  WV.galerie = function (gal) {
    if (!gal) return null;
    if (gal.wvGal) return gal.wvGal;
    var main = gal.querySelector('.wv-gal__main'), vign = gal.querySelector('.wv-gal__vign');
    if (!main) return null;
    var thumbs = vign ? Array.prototype.slice.call(vign.querySelectorAll('button')) : [];
    var img0 = main.querySelector('img');
    var srcs = thumbs.length ? thumbs.map(function (b) { return b.getAttribute('data-src'); }) : (img0 ? [img0.currentSrc || img0.src] : []);
    var alt = img0 ? img0.alt : '';
    var piste = document.createElement('div');
    piste.className = 'wv-gal__piste'; piste.tabIndex = 0;
    piste.setAttribute('role', 'region'); piste.setAttribute('aria-roledescription', 'carrousel'); piste.setAttribute('aria-label', 'Photos du produit');
    var slideBig = document.createElement('div');
    slideBig.className = 'wv-gal__slide wv-gal__slide--big'; slideBig.hidden = true;
    var big = main.querySelector('[data-wv-gal-big]');
    if (big) { slideBig.appendChild(big); big.hidden = false; }
    piste.appendChild(slideBig);
    var videos = [];
    srcs.forEach(function (src, i) {
      var d = document.createElement('div'), im, tb = thumbs[i], vsrc = tb && tb.getAttribute('data-video');
      d.className = 'wv-gal__slide';
      if (vsrc && i > 0) {
        /* Vidéo de galerie : muette, en boucle, inline, poster ; source chargée seulement à l'approche, pause hors écran */
        im = document.createElement('video');
        im.muted = true; im.loop = true; im.playsInline = true; im.preload = 'none';
        im.setAttribute('muted', ''); im.setAttribute('playsinline', ''); im.setAttribute('loop', ''); im.setAttribute('disablepictureinpicture', '');
        im.setAttribute('aria-label', tb.getAttribute('aria-label') || 'Vidéo');
        im.poster = tb.getAttribute('data-poster') || '';
        im.setAttribute('data-src', vsrc);
        d.classList.add('wv-gal__slide--video'); videos.push(im);
      }
      else if (i === 0 && img0) { im = img0; im.removeAttribute('hidden'); }
      else { im = document.createElement('img'); im.alt = ''; im.width = 1200; im.height = 1200; if (i > 1) im.loading = 'lazy'; im.src = src; }
      im.draggable = false; d.appendChild(im); piste.appendChild(d);
    });
    WV.videosAuto(videos);
    if (!srcs.length && img0) { var d0 = document.createElement('div'); d0.className = 'wv-gal__slide'; d0.appendChild(img0); piste.appendChild(d0); }
    main.insertBefore(piste, main.firstChild);
    var cpt = document.createElement('span'); cpt.className = 'wv-gal__compteur'; cpt.setAttribute('aria-hidden', 'true'); main.appendChild(cpt);
    var flG = main.querySelector('.wv-gal__fl--g'), flD = main.querySelector('.wv-gal__fl--d');
    if (!flG && srcs.length > 1) {
      flG = document.createElement('button'); flG.type = 'button'; flG.className = 'wv-gal__fl wv-gal__fl--g'; flG.setAttribute('aria-label', 'Image précédente'); flG.textContent = '←'; main.appendChild(flG);
      flD = document.createElement('button'); flD.type = 'button'; flD.className = 'wv-gal__fl wv-gal__fl--d'; flD.setAttribute('aria-label', 'Image suivante'); flD.textContent = '→'; main.appendChild(flD);
    }
    var cur = -1, raf = 0;
    function slides() { return Array.prototype.slice.call(piste.children).filter(function (x) { return !x.hidden; }); }
    function decal() { return slideBig.hidden ? 0 : 1; }
    function brut() { return Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)); }
    function maj(force) {
      var n = slides().length, i = Math.max(0, Math.min(brut(), n - 1));
      gal.classList.toggle('wv-gal--1', n < 2);
      if (i === cur && !force) return;
      cur = i; cpt.textContent = (i + 1) + ' / ' + n;
      var t = thumbs[i - decal()];
      thumbs.forEach(function (b) { b.classList.toggle('is-on', b === t); });
      if (t && vign && vign.scrollWidth > vign.clientWidth) vign.scrollTo({ left: t.offsetLeft - (vign.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      var s = slides(), nx = s[i + 1], im = nx && nx.querySelector('img');
      if (im) im.loading = 'eager';
      var vn = nx && nx.querySelector('video[data-src]');           /* vidéo suivante : on prépare sa source */
      if (vn && !vn.getAttribute('src')) { vn.preload = 'metadata'; vn.src = vn.getAttribute('data-src'); }
    }
    function aller(i, instant) {
      var n = slides().length; if (!n) return;
      i = ((i % n) + n) % n;
      piste.scrollTo({ left: i * piste.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      if (instant) maj(true);
    }
    /* Glisser à la souris (desktop, émulateurs) : le doigt utilise le défilement natif ci-dessus */
    var drag = null;
    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, sl: piste.scrollLeft, i: cur, bouge: false };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.bouge && Math.abs(dx) < 6) return;
      if (!drag.bouge) { drag.bouge = true; piste.style.scrollSnapType = 'none'; piste.style.cursor = 'grabbing'; }
      piste.scrollLeft = drag.sl - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return;
      var d = drag; drag = null;
      if (!d.bouge) return;
      var dx = e.clientX - d.x, n = slides().length, cible = d.i + (dx < -40 ? 1 : dx > 40 ? -1 : 0);
      cible = Math.max(0, Math.min(n - 1, cible));
      piste.style.cursor = '';
      piste.scrollTo({ left: cible * piste.clientWidth, behavior: 'smooth' });
      setTimeout(function () { piste.style.scrollSnapType = ''; }, 450);
    });
    piste.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; maj(); }); }, { passive: true });
    window.addEventListener('resize', function () { if (cur > -1) piste.scrollLeft = cur * piste.clientWidth; });
    if (flG) flG.addEventListener('click', function (e) { e.stopPropagation(); aller(cur - 1); });
    if (flD) flD.addEventListener('click', function (e) { e.stopPropagation(); aller(cur + 1); });
    thumbs.forEach(function (b, j) { b.addEventListener('click', function (e) { e.stopPropagation(); aller(j + decal()); }); });
    var api = gal.wvGal = {
      aller: aller, index: function () { return cur; },
      suivant: function () { aller(cur + 1); }, precedent: function () { aller(cur - 1); },
      allerVignette: function (j) { aller(j + decal()); },
      montrerBig: function () { slideBig.hidden = false; aller(0, true); }
    };
    maj(true);
    return api;
  };

  /* Vidéos de galerie : lecture auto (muette, en boucle) quand la diapo est visible à 60 %, pause sinon.
     La source (data-src) n'est posée qu'au premier affichage (chargement différé). */
  function srcVideo(v) { if (!v.getAttribute('src') && v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); } }
  WV.videosAuto = function (list) {
    if (!list || !list.length) return;
    if (!('IntersectionObserver' in window)) { list.forEach(function (v) { v.preload = 'metadata'; srcVideo(v); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.6) { srcVideo(v); v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.6, 1] });
    list.forEach(function (v) { io.observe(v); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) list.forEach(function (v) { if (!v.paused) v.pause(); }); });
  };

  /* Carrousel « Ils portent leurs voyages » : vidéos verticales, lecture au tap (une seule à la fois), muettes, en boucle,
     source chargée au premier tap, pause quand la carte sort de l'écran. Flèches sur desktop. */
  function carrouselVideos() {
    var root = document.querySelector('[data-wv-vc]');
    if (!root) return;
    var rail = root.querySelector('[data-wv-vc-rail]'), items = Array.prototype.slice.call(root.querySelectorAll('[data-wv-vc-item]'));
    function stop(it) { var v = it.querySelector('video'); if (!v.paused) v.pause(); it.classList.remove('is-play'); it.setAttribute('aria-pressed', 'false'); }
    items.forEach(function (it) {
      var v = it.querySelector('video');
      v.muted = true;
      it.addEventListener('click', function () {
        if (!v.paused) { stop(it); return; }
        items.forEach(function (o) { if (o !== it) stop(o); });
        srcVideo(v); var p = v.play(); if (p && p.catch) p.catch(function () {});
        it.classList.add('is-play'); it.setAttribute('aria-pressed', 'true');
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.intersectionRatio < 0.3) stop(e.target); }); }, { threshold: [0, 0.3] });
      items.forEach(function (it) { io.observe(it); });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-wv-vc-fl]'), function (b) {
      b.addEventListener('click', function () {
        var w = items[0] ? items[0].getBoundingClientRect().width + 14 : 260;
        rail.scrollBy({ left: (b.getAttribute('data-wv-vc-fl') === 'd' ? 1 : -1) * w * 2, behavior: 'smooth' });
      });
    });
  }

  /* Accueil voyage mobile : la bulle de chat est masquée tant que le bouton « Commencer ma collection » du héros est à l'écran */
  function bulleAccueil() {
    var cta = document.querySelector('[data-wv-hero-cta]');
    if (!cta || !('IntersectionObserver' in window)) return;
    var h = document.documentElement;
    new IntersectionObserver(function (es) { h.classList.toggle('wv-cta-visible', es[0].isIntersecting); }, { threshold: 0 }).observe(cta);
  }

  /* Barre fixe du configurateur : la page réserve exactement sa hauteur (plus de contenu masqué en bas) */
  function barreFixe() {
    var b = document.querySelector('[data-wv-barre]');
    if (!b) return;
    var h = document.documentElement;
    h.classList.add('wv-a-barre');
    function mesure() { h.style.setProperty('--wv-barre-h', b.offsetHeight + 'px'); }
    mesure();
    if (window.ResizeObserver) new ResizeObserver(mesure).observe(b);
    window.addEventListener('resize', mesure);
  }


  /* Modales (<dialog>) : [data-wv-modale="id"] ouvre, [data-wv-modale-fermer] ou clic sur le fond ferme */
  function modales() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-wv-modale]');
      if (o) { var d = document.getElementById(o.getAttribute('data-wv-modale')); if (d && d.showModal && !d.open) d.showModal(); return; }
      var f = e.target.closest('[data-wv-modale-fermer]');
      if (f) { var df = f.closest('dialog'); if (df) df.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('wv-modale') && e.target.open) e.target.close();
    });
  }

  /* Bandeau d'annonce qui tourne toutes les 4 s */
  function bandeau() {
    var rail = document.querySelector('[data-wv-annonce]');
    if (!rail) return;
    var ps = rail.querySelectorAll('p'), i = 0;
    if (ps.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(function () { ps[i].classList.remove('is-on'); i = (i + 1) % ps.length; ps[i].classList.add('is-on'); }, 4000);
  }
  function menu() {
    var b = document.querySelector('[data-wv-burger]'), n = document.querySelector('[data-wv-nav]');
    if (!b || !n) return;
    b.addEventListener('click', function () { var o = n.classList.toggle('is-open'); b.setAttribute('aria-expanded', o ? 'true' : 'false'); });
  }
  /* Page panier : boutons +/− et suppression */
  function panier() {
    var root = document.querySelector('[data-wv-panier]');
    if (!root) return;
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wv-qte]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      jsonFetch('/cart/change.js', { id: btn.getAttribute('data-key'), quantity: parseInt(btn.getAttribute('data-wv-qte'), 10) })
        .then(function () { return WV.reconcilier(); })
        .then(function () { window.location.reload(); })
        .catch(function (err) { alert(err.message); btn.disabled = false; });
    });
    WV.reconcilier().then(function (cart) {
      if (cart.wvChange || root.getAttribute('data-n') !== String(cart.item_count)) window.location.reload();
    }).catch(function () {});
  }

  function init() {
    bandeau(); menu(); barreFixe(); modales(); carrouselVideos(); bulleAccueil();
    Array.prototype.forEach.call(document.querySelectorAll('[data-wv-gal], [data-wv-fgal]'), WV.galerie);
    if (document.querySelector('[data-wv-panier]')) panier();
    else if (!document.querySelector('[data-wv-config], [data-wv-patch]')) WV.reconcilier().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
